import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'components/ui';
import './style.css';

class ClickToCopy extends Component {
  textareaElement = null;

  constructor(props) {
    super(props);
    this.textareaElement = React.createRef();
  }

  state = {
    tooltipText: 'Click to copy.',
  };

  handleCopyToClipboard = () => {
    const { value } = this.props;
    this.textareaElement.current.value = value;
    this.textareaElement.current.select();
    document.execCommand('copy');
    this.updateToolTipText();
  };

  updateToolTipText = () => {
    this.setState({ tooltipText: 'Copied!' });
    setTimeout(() => {
      this.setState({ tooltipText: 'Click to copy.' });
    }, 1000);
  };

  render() {
    const { children } = this.props;
    const { tooltipText } = this.state;

    return (
      <div className="click-to-copy">
        <Tooltip title={tooltipText}>
          <button type="button" onClick={this.handleCopyToClipboard}>
            {children}
          </button>
        </Tooltip>
        <textarea
          className="text-area-for-copying-text"
          ref={this.textareaElement}
        />
      </div>
    );
  }
}

ClickToCopy.defaultProps = {
  children: '',
};

ClickToCopy.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  value: PropTypes.string.isRequired,
};

export default ClickToCopy;
